import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$6 } from './button.js';
import { d as defineCustomElement$5 } from './icon.js';
import { d as defineCustomElement$4 } from './loader.js';
import { d as defineCustomElement$3 } from './menu-pane.js';
import { d as defineCustomElement$2 } from './tooltip.js';
import { d as defineCustomElement$1 } from './tooltip-label.js';

const moreMenuCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative;width:min-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}wui-list{max-width:240px;min-width:120px}";
const WuiMoreMenuStyle0 = moreMenuCss;

const WuiMoreMenu = /*@__PURE__*/ proxyCustomElement(class WuiMoreMenu extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.openChanged = createEvent(this, "openChanged", 3);
        this.toggleMenu = (open = !this.open) => {
            if (open === this.open) {
                return;
            }
            this.open = open;
            this.openChanged.emit(this.open);
        };
        this.label = undefined;
        this.icon = undefined;
        this.iconPosition = 'leading';
        this.buttonType = undefined;
        this.tooltip = undefined;
        this.disabled = false;
        this.loading = false;
        this.closeOnClickInside = false;
        this.menuPane = undefined;
        this.open = false;
    }
    render() {
        const type = this.buttonType || (this.icon && this.label ? 'tertiary' : this.icon ? 'icon' : 'primary');
        return (h(Host, { key: '59d2dd17b655b6f54ef99295d7967c61a43e904b', role: "button", disabled: this.disabled }, h("wui-button", { key: 'ea4796da71719667d039dc5f634b8fce4f27091d', icon: this.icon, label: this.label, tooltip: this.tooltip, type: type, iconPosition: this.iconPosition, disabled: this.disabled, loading: this.loading, onClick: () => {
                this.toggleMenu();
            } }), h("wui-menu-pane", { key: '8e63786bae6f2b1584423a141f28b050b8e92a79', ...this.menuPane, open: this.open, onClick: (e) => {
                if (!this.closeOnClickInside) {
                    return;
                }
                const target = e.target;
                if (target.className.startsWith('wui-menu-pane')) {
                    return;
                }
                this.toggleMenu(false);
            }, onClickOutside: () => {
                this.toggleMenu(false);
            }, onOpenChanged: (e) => {
                this.toggleMenu(e.detail);
            } }, h("slot", { key: '55fa44c3ca092f3502830261f3d2f1d00602a544' }))));
    }
    static get style() { return WuiMoreMenuStyle0; }
}, [1, "wui-more-menu", {
        "label": [1],
        "icon": [1],
        "iconPosition": [1, "icon-position"],
        "buttonType": [1, "button-type"],
        "tooltip": [1],
        "disabled": [516],
        "loading": [516],
        "closeOnClickInside": [4, "close-on-click-inside"],
        "menuPane": [16],
        "open": [1540]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-more-menu", "wui-button", "wui-icon", "wui-loader", "wui-menu-pane", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiMoreMenu);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiMoreMenu as W, defineCustomElement as d };

//# sourceMappingURL=more-menu.js.map